import { Calendar } from "@progress/kendo-react-dateinputs";

import { CustomNavigationItem } from "./customNavigationItem";

import type { CalendarProps } from "@progress/kendo-react-dateinputs";

import "./DatePicker.scss";

const CustomCalendar = (props: CalendarProps) => (
  <Calendar {...props} navigationItem={CustomNavigationItem} />
);

export { CustomCalendar };
